import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordInput({ value, onChange, placeholder, autoComplete, required, dataTestId }) {
    const [show, setShow] = useState(false);
    return (
        <div className="relative">
            <input
                data-testid={dataTestId}
                type={show ? "text" : "password"}
                autoComplete={autoComplete}
                value={value}
                onChange={onChange}
                className="input-field pr-11"
                placeholder={placeholder}
                required={required}
            />
            <button
                type="button"
                onClick={() => setShow((s) => !s)}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-[#71717A] hover:text-[#0A1128]"
                tabIndex={-1}
                data-testid={dataTestId ? `${dataTestId}-toggle` : undefined}
                title={show ? "Hide password" : "Show password"}
            >
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
        </div>
    );
}
